// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__343O4","header":"MessagesList_header__2m_xK","chat":"MessagesList_chat__1Sd55"};